import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { Observable } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';
import { Cohort, CohortService } from 'src/app/cohorts/services/cohort.service';
import {
  Release,
  ReleaseResponse,
  ReleaseService,
} from 'src/app/releases/services/release.service';

@Component({
  selector: 'cohort-release-search',
  templateUrl: './cohort-release-search.component.html',
  styleUrls: ['./cohort-release-search.component.scss'],
})
export class CohortReleaseSearchComponent implements OnInit {
  @Input() placeHolder: string;
  @Output() select: EventEmitter<Release | Cohort> = new EventEmitter<
    Release | Cohort
  >();
  @ViewChild('input', { static: false }) input: ElementRef;

  allCohorts: Cohort[];
  releaseResponse: ReleaseResponse;
  allReleases: Release[];
  selectedReleasesAndCohorts: string[] = [];

  constructor(
    private cohortService: CohortService,
    private releaseService: ReleaseService,
    private cdr: ChangeDetectorRef,
  ) {}

  async ngOnInit() {
    this.searchBinding = this.searchBinding.bind(this);
    this.formatResults = this.formatResults.bind(this);
    await this.initializeData();
  }

  async initializeData(): Promise<void> {
    this.allCohorts = await this.cohortService.getActiveCohorts();
    this.releaseResponse = await this.releaseService.getReleases();
    this.allReleases = this.releaseResponse.releases;
  }

  searchBinding(
    searched: Observable<string>,
  ): Observable<(Release | Cohort)[]> {
    return searched.pipe(
      distinctUntilChanged(),
      map((searchTerm) => {
        const matchedCohorts = this.allCohorts.filter((s) =>
          s.name.toLocaleLowerCase().includes(searchTerm.toLocaleLowerCase()),
        );

        const matchedReleases = this.allReleases.filter((r) =>
          r.name.toLocaleLowerCase().includes(searchTerm.toLocaleLowerCase()),
        );

        return [...matchedCohorts, ...matchedReleases];
      }),
    );
  }

  formatResults(item: Release | Cohort): string {
    if (this.isRelease(item)) {
      return `${item.name} (Release)`;
    }

    return `${item.name} (Cohort)`;
  }

  onSelectItem(selectedItem: any): void {
    this.select.emit(selectedItem.item);
    this.selectedReleasesAndCohorts.push(selectedItem.item);
    selectedItem.preventDefault?.();
    this.clearInput();
  }

  private isRelease(item: Release | Cohort): item is Release {
    return 'modules' in item;
  }

  private clearInput() {
    this.input.nativeElement.value = '';
    this.cdr.detectChanges();
  }
}
